export function useGoogleAuth() {
  const clientId = process.env.VUE_APP_GAPI_CLIENT_ID;
  const redirectUri =
    typeof window !== 'undefined' ? window.location.origin : '';

  async function getAuthCode() {
    return new Promise((resolve, reject) => {
      if (!clientId) {
        return reject(new Error('Google Client ID is not configured.'));
      }
      if (typeof window === 'undefined') {
        return reject(
          new Error('This function can only be run on the client side.'),
        );
      }

      const scope = [
        'https://www.googleapis.com/auth/userinfo.email',
        'https://www.googleapis.com/auth/drive',
        'https://www.googleapis.com/auth/drive.file',
        'https://www.googleapis.com/auth/gmail.send',
        'https://www.googleapis.com/auth/gmail.labels',
        'https://www.googleapis.com/auth/gmail.readonly',
      ].join(' ');
      const responseType = 'code';
      const accessType = 'offline';
      const prompt = 'consent select_account';

      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
      authUrl.searchParams.set('client_id', clientId);
      authUrl.searchParams.set('redirect_uri', redirectUri);
      authUrl.searchParams.set('scope', scope);
      authUrl.searchParams.set('response_type', responseType);
      authUrl.searchParams.set('access_type', accessType);
      authUrl.searchParams.set('prompt', prompt);

      const authWindow = window.open(
        authUrl.toString(),
        '_blank',
        'width=500,height=600',
      );

      const interval = setInterval(() => {
        try {
          if (authWindow && authWindow.location.href.startsWith(redirectUri)) {
            const url = new URL(authWindow.location.href);
            const code = url.searchParams.get('code');
            clearInterval(interval);
            authWindow.close();
            if (code) {
              resolve(code);
            } else {
              reject(
                new Error('No authorization code found in the redirect URI.'),
              );
            }
          }
        } catch {
          if (authWindow && authWindow.closed) {
            clearInterval(interval);
            reject(new Error('Authorization window was closed by the user.'));
          }
        }
      }, 500);
    });
  }

  return { getAuthCode };
}
